import { render, staticRenderFns } from "./show-more-by-count.vue?vue&type=template&id=d96f164c&"
import script from "./show-more-by-count.vue?vue&type=script&lang=js&"
export * from "./show-more-by-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports